import { UserEntity } from 'domain/user/UserEntity'

import { UserGroup } from '../models/UserGroup'

export class UserGroupService {
  /**
   * Filters domain user groups by search query
   */
  static filterGroups(groups: UserGroup[], searchQuery: string): UserGroup[] {
    const query = searchQuery.trim().toLowerCase()
    if (!query) return groups
    return groups.filter((g) => g.groupName.toLowerCase().includes(query))
  }

  /**
   * Sorts domain user groups by creation time
   */
  static sortGroupsByCreatedAt(
    groups: UserGroup[],
    direction: 'desc' | 'asc' = 'desc'
  ): UserGroup[] {
    return [...groups].sort((a, b) => {
      const timeA = a.createdAt ? new Date(a.createdAt).getTime() : 0
      const timeB = b.createdAt ? new Date(b.createdAt).getTime() : 0
      return direction === 'desc' ? timeB - timeA : timeA - timeB
    })
  }

  /**
   * Toggles individual user selection for group membership
   */
  static toggleUserSelection(
    selectedUserIds: number[],
    userId: number
  ): number[] {
    return selectedUserIds.includes(userId)
      ? selectedUserIds.filter((id) => id !== userId)
      : [...selectedUserIds, userId]
  }

  /**
   * Toggles select-all status for a filtered list of users
   */
  static toggleAllFilteredUsers(
    selectedUserIds: number[],
    filteredUsers: UserEntity[]
  ): number[] {
    const filteredIds = filteredUsers.map((u) => u.id)
    const isAllSelected = filteredIds.every((id) =>
      selectedUserIds.includes(id)
    )

    if (isAllSelected) {
      return selectedUserIds.filter((id) => !filteredIds.includes(id))
    }
    return Array.from(new Set([...selectedUserIds, ...filteredIds]))
  }

  /**
   * Validates group form payload rules
   */
  static validateGroupPayload(
    groupName: string,
    selectedUserIds: number[]
  ): { isValid: boolean; errorKey?: string } {
    const trimmed = groupName.trim()
    if (!trimmed) {
      return { isValid: false, errorKey: 'nameRequired' }
    }
    if (trimmed.length > 100) {
      return { isValid: false, errorKey: 'nameTooLong' }
    }
    if (selectedUserIds.length === 0) {
      return { isValid: false, errorKey: 'membersRequired' }
    }
    return { isValid: true }
  }
}

export default UserGroupService
